import { useState } from 'react'
import { differenceInMinutes, sub } from 'date-fns'

const useGlobalDatePicker = (initialValues = {}) => {
  const [start, setStart] = useState(initialValues?.start || sub(new Date(), { days: 1 }))
  const [end, setEnd] = useState(initialValues?.end || new Date())
  const [range, setRange] = useState(24 * 60)
  const [relativeSpan, setRelativeSpan] = useState(initialValues?.relativeSpan || 24 * 60)
  const [refreshInterval, setRefreshInterval] = useState(false)

  const handleSelectRange = (start, end, relativeSpan) => {
    setStart(start)
    setEnd(end)
    setRange(differenceInMinutes(end, start))
    setRefreshInterval(false)
    setRelativeSpan(relativeSpan || false)
  }

  const handleIntervalChange = (e) => {
    const valueInMs = e.target.value
    if (valueInMs === 'false') return setRefreshInterval(false)
    setRefreshInterval(parseInt(valueInMs))
  }

  return { start, end, range, relativeSpan, refreshInterval, handleSelectRange, handleIntervalChange }
}

export default useGlobalDatePicker
